import { storeToRefs, defineStore, acceptHMRUpdate } from 'pinia'
import { ref, computed } from 'vue'
import { useReturnCarrier } from '@/composables/returnCarrier.js'
import { useAccountStore } from '@/stores/account.js'
import { useClientStore } from '@shared/stores/client.js'
import { useClosetStore } from '@shared/stores/closet.js'

export const useFedExOptInStore = defineStore('fedExOptIn', () => {
  const {
    isSeattleLocal,
    fedexPreferred
  } = useReturnCarrier()
  const {
    getPreviousPickupConfirmationCode,
    getPickupLocations,
  } = useAccountStore()
  const { getReturnPackages } = useClientStore()
  const { showFedexSuccessModal: showSuccessModal, returnPackages } = storeToRefs(useClientStore())
  const { toReturnItems } = storeToRefs(useClosetStore())
  const bannerDismissed = ref(false)
  const recentFedexPickup = ref(null)

  const itemsToReturn = computed(() => toReturnItems.value.length > 0)

  const itemsInTransit = computed(() => returnPackages.value.length > 0 && returnPackages.value[0].trackingStatus === 'TRANSIT')

  const showFedExPickupBanner = computed(() =>
    fedexPreferred.value && // opted into fedex
    itemsToReturn.value && // has items to return
    !recentFedexPickup.value && // no recent fedex pickup scheduled
    !itemsInTransit.value && // last return package not in transit
    !isSeattleLocal.value && // is not eligible for delivery
    !bannerDismissed.value // has not dismissed the banner
  )

  function dismissFedExBanner () {
    bannerDismissed.value = true
  }

  async function initializeFedExInfo () {
    const { confirmationCode } = await getPreviousPickupConfirmationCode()
    recentFedexPickup.value = confirmationCode
    await getPickupLocations()
    await getReturnPackages(1)
  }

  return {
    initializeFedExInfo,
    showSuccessModal,
    bannerDismissed,
    dismissFedExBanner,
    fedexPreferred,
    showFedExPickupBanner,
    isSeattleLocal,
    toReturnItems,
    returnPackages,
    recentFedexPickup
  }
})

import.meta.hot?.accept(acceptHMRUpdate(useFedExOptInStore, import.meta.hot))
